import weekSelectPlugin from 'flatpickr/dist/plugins/weekSelect/weekSelect';

common.View.create('crud::form.inputs.Date', {

    options: [],

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initSetup();
        this.initOptions();
        this.initGui();
    },

    initSetup() {
        flatpickr.l10ns.default.firstDayOfWeek = 1; // Monday
        flatpickr.localize(flatpickr.l10ns.nl);
    },

    initOptions() {
        // Get options from data
        this.options = this.element.find('input').data();

        // Has week select plugin?
        if (this.element.find('input').attr('weekSelect')) {
            this.initWeekSelect();
        }

        // Change options?
        // ...
    },

    initWeekSelect() {
        // Set plugin
        this.options.plugins = [new weekSelectPlugin()];

        // Show week numbers
        this.options.weekNumbers = true;

        // Set on change event
        this.options.onChange = (date, dateStr, instance) => {
            let result = '';

            // Get week number
            // result += (instance.selectedDates[0]
            //     ? 'Week ' + instance.config.getWeek(instance.selectedDates[0]) + ' '
            //     : null);

            // Get date data
            result += [
                instance.weekStartDay,
                instance.weekEndDay,
            ]
                .map(d => instance.formatDate(d, 'd-m-Y'))
                .join(' t/m ')

            instance.input.value = result;
        }
    },

    /**
     * Initializes the GUI.
     */
    initGui() {
        let input = this.element.find('input');
        let rangedate = this.element.find('.rangedate:not([readonly]');
        let multidate = this.element.find('.multidate:not([readonly]')
        let singledate = this.element.find('.singledate:not([readonly]')

        if (input.hasClass('rangedate')) {
            rangedate.flatpickr({
                ...this.options,
                "mode": "range",
                allowInput: true,
            });
        } else if (input.hasClass('multidate')) {
            multidate.flatpickr({
                ...this.options,
                "mode": "multiple",
                allowInput: true,
            });
        } else {
            singledate.flatpickr({
                ...this.options,
                allowInput: true,
            });
        }
    },

});
